import { ref, computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { refDebounced } from '@vueuse/core'
import fetchData from '@/util/fetch'

export const searchLocations = async (query) => {
  const urlParams = new URLSearchParams({ query })
  const result = await fetchData(`/tickets/api/v1/locations?${urlParams}`)
  return result.data
}

export const useAddressOptions = () => {
  const searchInput = ref('')
  const query = refDebounced(searchInput, 400)

  const addressesQuery = useQuery({
    queryKey: computed(() => ['location-addresses', query.value]),
    queryFn: async () => {
      if (!query.value || query.value.length < 2) return []
      return (await searchLocations(query.value)).map((location) => ({
        value: location.location_id,
        label: location.legacy_address,
      }))
    },
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  })

  return {
    addresses: computed(() => addressesQuery.data.value),
    search: (q) => {
      searchInput.value = q
    },
  }
}
